import React, { FC } from 'react';
import { Filter, SafeHtml } from '@shared/ui';
import { CdnIcon } from '@shared/ui';
import { useTheme } from '../../../../../theme';
import { ExchangeRefundBreadcrumb } from '../../model';

interface Props {
	breadcrumbs: ExchangeRefundBreadcrumb[];
}

const ExchangeRefundBreadcrumbs: FC<Props> = ({ breadcrumbs }) => {
	const { ExchangeRefundBreadcrumbs: css } = useTheme('Entities').Order;

	return (
		<>
			{breadcrumbs.map(breadcrumb => (
				<Filter
					key={breadcrumb.id}
					classes={{ root: css.breadcrumb }}
					icon={breadcrumb.icon ? <CdnIcon icon={breadcrumb.icon} /> : undefined}
					label={<SafeHtml html={breadcrumb.label} tag={'span'} />}
					isSelected
					size="large"
					quantity={breadcrumb.passengersCount}
					onClick={breadcrumb.onAction}
					isDisabled={breadcrumb.disabled}
				/>
			))}
		</>
	);
};

export default ExchangeRefundBreadcrumbs;
